import { t } from 'i18next';
import { useEffect, useRef } from 'react';
import { useFormItem } from '../../../common/hooks/use-form-item';
import { InputType } from '../../../common/hooks/use-form-item/types';
import { and } from '../../../common/hooks/use-form-item/validators/compositions';
import { required } from '../../../common/hooks/use-form-item/validators/existential';
import { maxLength, notEquals } from '../../../common/hooks/use-form-item/validators/operational';
import { ProfileStore } from '../store/ProfileStore';

export const PROFILE_MAX_NAME_LENGTH = 1000;

type Props = {
  store: ProfileStore;
};

export const ProfileNameInput = ({ store }: Props) => {
  const value = useRef(store.getEditableProfileName());

  const [name, nameComponent, valid] = useFormItem<string>({
    type: InputType.TYPE_TEXT,
    label: t('createProfileForm.name.input'),
    value: value.current,
    validator: and(required(), maxLength(PROFILE_MAX_NAME_LENGTH), notEquals(store.getOriginalProfileName(), { neqValue: 'createProfileForm.name.neq' })),
    inputOptions: {
      autoFocus: true,
      showRequiredIndicator: true,
      focusedLabel: t('createProfileForm.name.focused'),
      help: t('createProfileForm.name.help'),
    },
    textOptions: { trimOnBlur: true },
  });

  useEffect(() => {
    if (valid) {
      store.setEditableProfileName(name);
    } else {
      store.setEditableProfileName(null);
    }
  }, [name, valid, store]);

  return nameComponent;
};
